import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Testimonials from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Instructions from './components/Instructions';

const HomePage = () => {
  const { currentLanguage } = useLanguage();
  const isSimplified = currentLanguage === 'cs' || currentLanguage === 'en';

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        {!isSimplified && (
          <>
            <About />
            <Skills />
            <Testimonials />
            <Contact />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

const AppContent = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/instructions" element={<Instructions />} />
      <Route path="/instructions.html" element={<Instructions />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
}

export default App;
